// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPropagateOverridablePropertiesResponse
 */
export interface IPropagateOverridablePropertiesResponse {
    /**
     * 
     * @type {number}
     * @memberof IPropagateOverridablePropertiesResponse
     */
    updated_organizations_number?: number;
}

/**
 * Check if a given object implements the IPropagateOverridablePropertiesResponse interface.
 */
export function instanceOfIPropagateOverridablePropertiesResponse(value: object): value is IPropagateOverridablePropertiesResponse {
    return true;
}

export function IPropagateOverridablePropertiesResponseFromJSON(json: any): IPropagateOverridablePropertiesResponse {
    return IPropagateOverridablePropertiesResponseFromJSONTyped(json, false);
}

export function IPropagateOverridablePropertiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPropagateOverridablePropertiesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'updated_organizations_number': json['updated_organizations_number'] == null ? undefined : json['updated_organizations_number'],
    };
}

export function IPropagateOverridablePropertiesResponseToJSON(json: any): IPropagateOverridablePropertiesResponse {
    return IPropagateOverridablePropertiesResponseToJSONTyped(json, false);
}

export function IPropagateOverridablePropertiesResponseToJSONTyped(value?: IPropagateOverridablePropertiesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'updated_organizations_number': value['updated_organizations_number'],
    };
}

